import { Html } from "@react-three/drei";
import { useLocation } from "react-router-dom";

type MapLabelProps = {
  position: [number, number, number];
  title: string;
  walk?: string;
};

const MapLabel = ({ position, title, walk }: MapLabelProps) => {
  const pathname = useLocation().pathname;
  return (
    <group position={position}>
      <Html color="white" center={true}>
        <div
          style={{
            opacity: pathname === "/the-location" ? 1 : 0,
            borderRadius: "10px",
            border: "1px solid var(--secondary)",
            backgroundColor: "var(--primary)",
            display: "flex",
            flexDirection: "column",
            whiteSpace: "nowrap",
            padding: ".5rem 1rem",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <h1
            style={{
              fontSize: "1rem",
              fontWeight: 600,
              color: "#83474A",
            }}
          >
            {title}
          </h1>
          {walk && (
            <h2
              style={{
                fontFamily: "secondaryFont",
                fontSize: ".8rem",
                fontWeight: 600,
                color: "var(--secondary)",
              }}
            >
              {walk} minutes Walk
            </h2>
          )}
        </div>
      </Html>
    </group>
  );
};

export default MapLabel;
